import MenuList_2 from './MenuList_2';
import MenuList_5 from './MenuList_5';
import MenuList_6 from './MenuList_6';
import MenuList_7 from './MenuList_7';
import MenuList_8 from './MenuList_8';

export const MenuList = {
  MenuList_2: MenuList_2,
  MenuList_5: MenuList_5,
  MenuList_6: MenuList_6,
  MenuList_7: MenuList_7,
  MenuList_8: MenuList_8,
};
